import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServiceDesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/index.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { queuesNavigationItems } from '@atlassian/jira-router-resources-service-desk-queues/src/services/index.tsx';
import { LazyIssueApp } from '@atlassian/jira-router-routes-common/src/async.tsx';
import { servicedeskIssuesRoute } from '@atlassian/jira-router-routes-issue-navigator-routes/src/index.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { ProjectIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/project-app.tsx';
import { getCommonProjectResources } from './common-project.tsx';
import { common } from './common.tsx';
import { ServiceDeskIssueNavigator, LazyServiceDeskProjectIssueNavigator } from './ui/index.tsx';

/**
 * Servicedesk Project Issue Navigator Route Entry
 * Handles JSM (Service management) projects, also known JSD (Servicedesk) projects.
 */
export const issueNavigatorProjectServicedeskRouteEntry = createEntry(
	servicedeskIssuesRoute,
	() => ({
		...common,
		component: ServiceDeskIssueNavigator,
		skeleton: ProjectIssueNavigatorSkeleton,
		forPaint: [LazyAtlassianNavigation, LazyServiceDeskProjectIssueNavigator],
		afterPaint: [LazyIssueApp],
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServiceDesk,
		},
		resources: [
			...getCommonProjectResources(),
			queuesNavigationItems,
			getConsolidationStateResource(),
		],
		layout: serviceProjectLayout,
	}),
);
